import React from 'react';
import { Position } from '../../../ui/Position';
import { HelpTipMount } from '../../core/help/HelpTip';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { EditorModeInfo } from '../EditorModeInfo';
import { useEditorSessionObserver } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { IsElevated } from './IsElevated';
import { useActiveMeeting } from './MeetingHooks';
import { MeetingHostHeaderButton } from './MeetingHostHeaderButton';
import { MeetingParticipantHeaderButton } from './MeetingParticipantHeaderButton';
import { MeetingStartHeaderButton } from './MeetingStartHeaderButton';
import { MeetingTimerView } from './MeetingTimerView';
import { ViewMode } from './ViewMode';

export const MeetingHeaderView = () => {

    const { canManage } = useEditorSessionObserver(MyRoleInfo);
    const isHost = useEditorSessionObserver(IsElevated);
    const editorMode = useEditorSessionObserver(EditorModeInfo);
    const meeting = useActiveMeeting();

    if (editorMode.id === ViewMode.id) return null;

    return <Flexer flex="row" align="center" gap="2">
        {!!meeting && <>
            {isHost ? <MeetingHostHeaderButton /> : <MeetingParticipantHeaderButton />}
            <MeetingTimerView />
        </>}
        {!meeting && !!canManage && <>
            <MeetingStartHeaderButton />
        </>}
        <Position at="bottom" inset="0">
            <HelpTipMount name="meetingHeader" placement="bottom" />
        </Position>
    </Flexer >;
};
